module.exports = __webpack_public_path__ + "img/CONTRATO DE GUATEMALA-3.1f22f524.jpg";